<template>
  <div>
    <navbar-header/>
    <b-container fluid class="mt-3">
      <b-row>
        <b-col md="12">
          <stats-workshop-screen></stats-workshop-screen>
          <stats-workshop-screen-m></stats-workshop-screen-m>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import NavbarHeader from '@/components/NavbarHeader'
import StatsWorkshopScreen from '@/components/StatsWorkshopScreen'
import StatsWorkshopScreenM from '@/components/StatsWorkshopScreenM'
export default {
  name: 'OverallWorkshopStat',
  components: {
    NavbarHeader,
    StatsWorkshopScreen,
    StatsWorkshopScreenM
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/OverallWorkshopStat.vue